import { createContext, useState } from "react";

// Create context with default values
export const RoleContext = createContext({
  roleId: null,
  setRoleId: () => {}
});

// Provider component
export const RoleProvider = ({ children, roleId: initialRoleId }) => {
  const [roleId, setRoleId] = useState(initialRoleId || null);

  return (
    <RoleContext.Provider value={{ roleId, setRoleId }}>
      {children}
    </RoleContext.Provider>
  );
};